import type { UseNotificationPermissions } from './useNotificationPermissions.types';

// ─────────────────────────────────────────────────────────────────────

/**
 * NOTE: We track notification permissions only on native platforms.
 */
export const useNotificationPermissions: UseNotificationPermissions = () => {
  return {
    isGranted: true,

    openSettings() {},
  };
};
